import Iconify from "minimals-template/components/Iconify"

export function BasketIcon({ sx, ...props }) {
    return <Iconify sx={{ width: 32, height: 32, color: "primary.main", ...sx }} icon="mdi:suit-hearts" {...props} />
}
